import axiosInstance from 'api/axiosInstance';

export interface CanPlateParkResponse {
	allowed: boolean;
	validFrom?: Date;
	validUntil?: Date;
}

export const canPlatePark = async (
	licenseNumber: string,
	licenseState: string,
	parkingLocationId: string,
): Promise<CanPlateParkResponse> => {
	try {
		const API_URL = `/api2.0/registeredPlates/canPlatePark?licenseNumber=${encodeURIComponent(
			licenseNumber,
		)}&licenseState=${encodeURIComponent(
			licenseState,
		)}&parkingLocationId=${parkingLocationId}`;

		const response = await axiosInstance.get(API_URL);

		// ✅ Convert validFrom and validUntil from ISO 8601 to Date objects
		const result: CanPlateParkResponse = {
			allowed: response.data.allowed,
			validFrom: response.data.validFrom
				? new Date(response.data.validFrom)
				: undefined,
			validUntil: response.data.validUntil
				? new Date(response.data.validUntil)
				: undefined,
		};

		return result;
	} catch (error) {
		console.error('❌ Error checking if plate can park:', error);
		throw error;
	}
};
